import { Container } from 'reactstrap'
import { H5, Image } from '../../../AbstractElements'
import CountdownData from '../CountdownData'
import { WeAreComingSoon } from '../../../Constant'
import { dynamicImage } from '../../../Service/DynamicImage'

const ComingSimpleContainer = () => {
  return (
    <Container fluid className='p-0'>
        <div className="comingsoon">
          <div className="comingsoon-inner text-center">
            <Image src={dynamicImage("other-images/logo-login.png")} alt="coming soon"/>
            <H5>{WeAreComingSoon}</H5>
            <div className="countdown" id="clockdiv">
            <CountdownData />
            </div>
          </div>
        </div>
      </Container>
  )
}

export default ComingSimpleContainer